















import LoginForm from '@/components/Auth/LoginForm.vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'LoginView',

    components: {
        LoginForm,
    },

    props: {
        initialMode: {
            type: String,
            default: 'login',
        },
    },

    asyncData({ store }) {
        // FIXME: Show correct title
        store.commit('setPageMeta', {
            title: 'Login / Signup',
        });
        return Promise.resolve();
    },

    created() {
        const next = this.$route.query.next ? this.$route.query.next : null;
        this.$store.commit('auth/setLoginRedirect', next);
    },

    methods: {
        onModeChange(mode) {
            switch (mode) {
                case 'login':
                    this.$router.replace('/login');
                    break;
                case 'signup':
                    this.$router.replace('/signup');
                    break;
            }
        },
    },
});
